import { camelCase, mapKeys } from 'lodash-es';
import { types } from './Checkout.actions';

const getPricing = ({ duration, products }) => {
  if (!products) {
    return {};
  }
  const currentProduct = products[duration];
  const priceWithoutDiscount = currentProduct.priceWithoutDiscount || 0;
  const {
    recurringAmount,
    currency,
    sku,
    amountInMinorUnits,
    billedToday,
    yearlyTotal,
    monthlyTotal,
    priceId,
    billedTodayOther,
    discounts
  } = currentProduct;
  return {
    recurringAmount,
    priceWithoutDiscount,
    duration,
    currency,
    sku,
    billedToday,
    yearlyTotal,
    monthlyTotal,
    priceId,
    amountInMinorUnits,
    billedTodayOther,
    discounts
  };
};

export const initCheckoutState = ({
  adyenClientPubkey,
  analyticsData,
  checkoutError,
  checkoutSubmitting,
  checkoutSuccess,
  checkoutSuccessRedirectPath,
  currency,
  dropInClientKey: clientKey,
  dropInEnvironment: environment,
  dropInSessionData: sessionData,
  dropInSessionEnabled: sessionEnabled,
  dropInSessionId: sessionId,
  duration,
  experiments,
  isStudentPromotion,
  isHolidayPromotion,
  isTrial,
  isTrialEligible,
  packageIds,
  products,
  promoCampaign,
  promoCodeError,
  promoCodeInputVisibility,
  promoCodeSubmitting,
  showPaypal,
  trialInfo,
  yearlyPercentOff
}) => {
  const pricing = getPricing({ duration, products });
  return {
    adyenClientPubkey,
    analyticsData,
    checkoutError,
    checkoutSubmitting,
    checkoutSuccess,
    checkoutSuccessRedirectPath,
    currency,
    clientKey,
    environment,
    sessionData,
    sessionEnabled,
    sessionId,
    duration,
    experiments,
    isStudentPromotion,
    isHolidayPromotion,
    isTrial,
    isTrialEligible,
    packageIds,
    pricing,
    products,
    promoCampaign,
    promoCodeError,
    promoCodeInputVisibility,
    promoCodeSubmitting,
    showPaypal,
    trialInfo,
    yearlyPercentOff
  };
};

export default function summitCheckoutAppReducer(state = {}, action) {
  let payload;
  let payloadCamelCase;
  switch (action.type) {
    case types.SET_DURATION:
      return {
        ...state,
        pricing: getPricing({
          duration: action.duration,
          products: state.products
        }),
        duration: action.duration
      };
    //
    // Adyen checkout block
    //
    case types.ADYEN_PRODUCT_CHECKOUT_REQUEST:
      return {
        ...state,
        checkoutSubmitting: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_SUCCESS:
      return {
        ...state,
        checkoutSuccess: true
      };
    case types.ADYEN_PRODUCT_CHECKOUT_FAILURE:
      return {
        ...state,
        checkoutSubmitting: false,
        checkoutError: true
      };
    case types.CLEAR_ADYEN_PRODUCT_CHECKOUT_ERROR:
      return {
        ...state,
        checkoutSubmitting: false,
        checkoutError: false
      };
    //
    // Promo code related
    //
    case types.CHECK_PROMO_CODE_REQUEST:
    case types.REMOVE_PROMO_CODE_REQUEST:
      return {
        ...state,
        promoCodeSubmitting: true
      };
    case types.CHECK_PROMO_CODE_SUCCESS:
    case types.REMOVE_PROMO_CODE_SUCCESS:
      return {
        ...state,
        pricing: getPricing({
          duration: action.payload.products.default_selected,
          products: action.payload.products
        }),
        promoCodeSubmitting: false,
        promoCodeError: false,
        promoCodeInputVisibility: false,
        products: action.payload.products,
        duration: action.payload.products.default_selected,
        sessionId: action.payload.dropInSessionId,
        sessionData: action.payload.dropInSessionData
      };
    case types.CHECK_PROMO_CODE_FAILURE:
    case types.REMOVE_PROMO_CODE_FAILURE:
      return {
        ...state,
        promoCodeSubmitting: false,
        promoCodeError: true
      };
    case types.TOGGLE_PROMO_CODE_INPUT_VISIBILITY:
      return {
        ...state,
        promoCodeInputVisibility: !state.promoCodeInputVisibility
      };
    case types.APP_PROPS_REFRESH_SUCCESS:
      ({ payload } = action);
      payloadCamelCase = mapKeys(payload, (val, key) => camelCase(key));
      return {
        ...state,
        ...payloadCamelCase,
        sessionId: payload.dropInSessionId,
        sessionData: payload.dropInSessionData,
        clientKey: payload.dropInClientKey,
        environment: payload.dropInEnvironment,
        pricing: getPricing({
          duration: payload.products.default_selected,
          products: payload.products
        })
      };
    case types.APP_PROPS_ORGANIC_REFRESH_SUCCESS:
      ({ payload } = action);
      payloadCamelCase = mapKeys(payload, (val, key) => camelCase(key));
      return {
        ...state,
        ...payloadCamelCase,
        promoCodeInputVisibility: true,
        sessionId: payload.dropInSessionId,
        sessionData: payload.dropInSessionData,
        clientKey: payload.dropInClientKey,
        environment: payload.dropInEnvironment,
        pricing: getPricing({
          duration: payload.products.default_selected,
          products: payload.products
        })
      };
    default:
      // some payloads include responses from APIs that are in snake case
      // we need to map snake case keys to camelCase
      return {
        ...mapKeys(state, (val, key) => camelCase(key)),
        pricing: getPricing(state)
      };
  }
}
